/* Me & My — New Arrivals category tabs (client-side tag filter).
   Tabs are rendered by sections/product-list.liquid when the section has a
   `mm_category_tabs` setting. Each product-card carries data-product-tags.
   Clicking a tab shows only cards whose tags include that tab's label.
   Products carrying none of the tab tags fall back to the first (default) tab
   so the default view is never empty during the build. */
(function () {
  function tagsOf(item) {
    var card = item.querySelector('[data-product-tags]');
    if (!card) return [];
    return (card.getAttribute('data-product-tags') || '')
      .toLowerCase()
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function initSection(section) {
    if (!section || section.dataset.mmArrivalsReady === '1') return;
    var tabs = section.querySelectorAll('.mm-arrivals-tab');
    if (!tabs.length) return;
    section.dataset.mmArrivalsReady = '1';

    var tabTags = [];
    tabs.forEach(function (t) {
      tabTags.push((t.getAttribute('data-mm-filter') || '').toLowerCase());
    });
    var defaultFilter = tabTags[0];
    var items = section.querySelectorAll('.resource-list__item');

    function apply(filter) {
      items.forEach(function (item) {
        var tags = tagsOf(item);
        var show;
        if (filter === '__all__' || filter === '') {
          show = true;
        } else {
          show = tags.indexOf(filter) !== -1;
        }
        item.classList.toggle('mm-hide', !show);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-selected', 'false');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');
        apply((t.getAttribute('data-mm-filter') || '').toLowerCase());
        section.dispatchEvent(new CustomEvent('mm-carousel:refresh'));
      });
    });

    apply(defaultFilter);
  }

  function initCarousel(section) {
    if (!section) return;
    var track = section.querySelector('.resource-list--grid');
    // Wait until the track exists AND has cards (recommendations load async).
    if (!track || track.dataset.mmCarInit === '1' || !track.querySelector('.resource-list__item')) return;
    track.dataset.mmCarInit = '1';

    // Wrap the scrolling track in a viewport that bleeds to the right screen
    // edge (CSS). Dots go below it.
    var viewport = document.createElement('div');
    viewport.className = 'mm-car-viewport';
    track.parentNode.insertBefore(viewport, track);
    viewport.appendChild(track);

    var dots = document.createElement('div');
    dots.className = 'mm-car-dots';
    viewport.parentNode.insertBefore(dots, viewport.nextSibling);

    // Prev / Next arrows so it's obvious there are more items to scroll.
    var CARET = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'mm-car-arrow mm-car-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous products');
    prevBtn.innerHTML = CARET;
    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'mm-car-arrow mm-car-arrow--next';
    nextBtn.setAttribute('aria-label', 'More products');
    nextBtn.innerHTML = CARET;
    viewport.appendChild(prevBtn);
    viewport.appendChild(nextBtn);
    prevBtn.addEventListener('click', function () { stop(); animateTo(track.scrollLeft - track.clientWidth * 0.85); });
    nextBtn.addEventListener('click', function () { stop(); animateTo(track.scrollLeft + track.clientWidth * 0.85); });

    function items() {
      return Array.prototype.slice.call(track.querySelectorAll('.resource-list__item')).filter(function (i) {
        return !i.classList.contains('mm-hide');
      });
    }
    function step() {
      var list = items();
      return list.length ? list[0].getBoundingClientRect().width + 15 : track.clientWidth * 0.8;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function currentIndex() { return Math.round(track.scrollLeft / step()); }

    // Smooth scroll — animate scrollLeft directly so it isn't cancelled by
    // scroll-snap; instant fallback if rAF is throttled (background tab).
    var raf = null, safety = null;
    function animateTo(to) {
      to = Math.max(0, Math.min(to, maxScroll()));
      var from = track.scrollLeft, dist = to - from;
      if (raf) cancelAnimationFrame(raf);
      if (safety) clearTimeout(safety);
      if (!dist) { updateDots(); return; }
      var dur = 450, t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var p = Math.min((now - t0) / dur, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + dist * ease;
        if (p < 1) { raf = requestAnimationFrame(frame); } else { track.scrollLeft = to; updateDots(); }
      }
      raf = requestAnimationFrame(frame);
      safety = setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 2) { track.scrollLeft = to; updateDots(); } }, dur + 200);
    }

    function buildDots() {
      dots.innerHTML = '';
      var list = items();
      var s = step();
      var perView = Math.max(1, Math.round(track.clientWidth / s));
      var pages = Math.max(1, list.length - perView + 1);
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'mm-car-dot';
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          d.addEventListener('click', function () { stop(); animateTo(idx * s); });
        })(i);
        dots.appendChild(d);
      }
      dots.hidden = pages <= 1;
      updateDots();
    }
    function updateDots() {
      var ci = currentIndex();
      var kids = dots.children;
      for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === ci);
      updateArrows();
    }
    function updateArrows() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll() - 2;
      var hasOverflow = maxScroll() > 4;
      prevBtn.classList.toggle('is-hidden', atStart || !hasOverflow);
      nextBtn.classList.toggle('is-hidden', atEnd || !hasOverflow);
    }

    // Autoplay
    var timer = null;
    function play() {
      stop();
      timer = setInterval(function () {
        // Snap to the next card index (not scrollLeft + step) so fractional
        // animation values don't accumulate and cut cards off on the left.
        var to = (currentIndex() + 1) * step();
        if (to > maxScroll() - 2) to = 0;
        animateTo(to);
      }, 4500);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', buildDots);
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', play);
    section.addEventListener('mm-carousel:refresh', function () { track.scrollLeft = 0; buildDots(); });

    buildDots();
    play();
  }

  function initAll() {
    document.querySelectorAll('[data-mm-arrivals]').forEach(initSection);
    document.querySelectorAll('[data-mm-carousel]').forEach(initCarousel);
  }

  // Related Products (product-recommendations) loads its cards asynchronously —
  // re-init the carousel once they appear.
  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      document.querySelectorAll('[data-mm-carousel]').forEach(initCarousel);
    }, 60);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when the section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector
      ? e.target.querySelector('[data-mm-arrivals]')
      : null;
    if (sec) {
      sec.dataset.mmArrivalsReady = '';
      initSection(sec);
    }
  });
})();
